import { Injectable } from "@angular/core";
import { StorageService } from "./storage.service";
import { environment as env} from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class HttpService {
  
  constructor(private storageService: StorageService) {
  }

  
  getOptions(headers: any) {
    const language = this.storageService.getFromLocalOrSessionStorage("language-locale") || env.defaultLanguage;
    const additionalHeaders = {
      ...headers,
      'language-locale': language
    };
    return  {
      headers: additionalHeaders
    }
  }
}
